import { faCaretLeft, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HTMLCode from "components/common/HTMLCode";
import React, { useEffect, useState } from "react";

type DatalistPaginationPropsViewType = {
    take?: number,
    skip?: number,
    totalCount: number,
    onPageChange: (page: number) => void | Promise<void>
    name: string
}

export type DatalistPaginationProps = DatalistPaginationPropsViewType & {
}

function calculateCurrentPage(skip: number | undefined, take: number | undefined, totalCount: number) {
    if(!skip || !take) return 1;
    let page = Math.ceil((skip + take) / totalCount);
    return page;
}

const DatalistPaginationView = (props: DatalistPaginationPropsViewType) => {
    const calculateCurrentPageIndex = () => calculateCurrentPage(props.skip, props.take, props.totalCount);
    let [totalPages, setTotalPages] = useState(props.take ? Math.ceil(props.totalCount / props.take) : 1);
    let [currentPage, setCurrentPage] = useState(calculateCurrentPageIndex());

    useEffect(() => {
        setCurrentPage(calculateCurrentPageIndex());
        setTotalPages(props.take ? Math.ceil(props.totalCount / props.take) : 1);
    }, [props.skip, props.take, props.totalCount])

    const onPageChange = () => {
        if(currentPage < 1 || currentPage > totalPages) {
            setCurrentPage(calculateCurrentPageIndex());
            return;
        }

        props.onPageChange((currentPage - 1) * props.take!);
    }

    const onPageFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        e.target.select();
    }

    const arrows = totalPages === 1 ? <>1</> : <div className="flex flex-nowrap gap-3">
        <button title="page" disabled={currentPage === 1} onClick={() => props.onPageChange(props.skip! - props.take!)}>
            <FontAwesomeIcon icon={faCaretLeft} />
        </button>
        <div className="p-1 border border-transparent hover:theme-border">
            <input 
                id={`app-datalist-pagination-${props.name}`}
                placeholder="page"
                className="bg-inherit text-inherit" 
                type="number" 
                onChange={e => setCurrentPage(Number(e.target.value))}
                min={1} 
                onKeyDown={onPageChange}
                onFocus={onPageFocus}
                onBlur={() => setCurrentPage(calculateCurrentPageIndex())}
                max={totalPages} 
                value={currentPage} 
                size={totalPages.toString().length} 
            />
        </div>
        <button 
            title="page" 
            disabled={currentPage === totalPages} 
            onClick={() => props.onPageChange(props.skip! + props.take!)}
        >
            <FontAwesomeIcon icon={faCaretRight} />
        </button>
    </div>

    const itemsListedInfo = () => {
        const skip = props.skip || 0;
        if(props.take) {
            let take = skip + props.take!;
            if(take > props.totalCount) take = props.totalCount;
            return <span>{skip + 1} - {take} / {props.totalCount}</span>
        } else {
            return <span>{skip + 1} - {props.totalCount} / {props.totalCount}</span>
        }
    }

    return(
        <div className="app-table_pagination p-3 flex flex-nowrap w-full">
            <div className="w-full my-auto">
                {itemsListedInfo()}
            </div>
            <div className="w-full text-right">
                <div className=" flex flex-nowrap float-right">
                    {arrows}
                    <div className=" my-auto">
                        <HTMLCode/><HTMLCode/><HTMLCode/>/<HTMLCode/>{totalPages}<HTMLCode/>
                    </div>
                </div>
            </div>
        </div>
    );
}

const DatalistPagination = (props: DatalistPaginationProps) => {
    if(props.totalCount === 0) return <></>;
    return <DatalistPaginationView {...props} />;
}

export default DatalistPagination;
